import { render } from "./MoveListModal.vue?vue&type=template&id=046ee1e8&scoped=true"
import script from "./MoveListModal.vue?vue&type=script&lang=js"
export * from "./MoveListModal.vue?vue&type=script&lang=js"

import "./MoveListModal.vue?vue&type=style&index=0&id=046ee1e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046ee1e8"]])

export default __exports__